/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class SurveyTypeFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			surveyTypes: []
		});
	}

	componentDidMount() {
		SurveyTypeService.Get()
			.then((x) => {
				this.setState({surveyTypes: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A Survey Type"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A Survey Type</option>
			{
				this.state.surveyTypes.map((x) => {
					return <option key={x.surveyTypeId} value={x.surveyTypeId}>{x.name}</option>;
				})
			}
		</FormControl>;
	}
}